export const TrSpace = () => {
    return (
        <>
        <tr><td><div className="w-full">&nbsp;</div></td></tr>
        </>
    );
};